export default "__VITE_PUBLIC_ASSET__6c3cbc11__"